import { createMuiTheme } from '@material-ui/core/styles';

const dividerColor = "#E0E5EC";
export const customTheme = createMuiTheme({
	palette: {
		primary: {
			main: '#18cc69',
			contrastText: '#fff',
		},
		secondary: {
			main: '#334D6E',
			contrastText: '#fff',
		},
		background: {
			default: "#fff",
			light: "#F5F8FA",
		},
		error: {
			main: "#de575e"
		},
		neutral: {
			main: "#c2cfe0"
		},
		divider: dividerColor,
	},
	typography: {
		fontFamily: `"Poppins-Medium","Arial","sans-serif"`,
		fontWeightLight: 400,
		fontWeightRegular: 500,
		fontWeightMedium: 600,
		fontWeightBold: 700,
	},
	shape: {
		roundedBorderRadius: 50,
	},
	overrides: {
		MuiTable: {
			root: {
				borderCollapse: "unset",
			}
		},
		MuiTableCell: {
			root: {
				borderBottomColor: dividerColor,
				padding: "16px !important",
			},
			head: {
				fontSize: 14,
				fontWeight: 500,
				color: "#555",
				borderBottomColor: dividerColor,
			},
			body: {
				fontSize: 13,
				fontWeight: 400,
				color: "#707683",
			},
		},
		MuiTableSortLabel: {
			active: {
				color: "#555 !important"
			}
		}
	},
});